import { RootState } from 'src/store';

import { ICommissionData } from './types';

export const selectCommissionsData = (state: RootState): ICommissionData => state.commission.data;
export const selectCommissionsIsLoading = (state: RootState): boolean => state.commission.isLoading;
export const selectCommissionsIsLoaded = (state: RootState): boolean => state.commission.isLoaded;
